module.exports = {
	"name": "Temperature",
	"desc": "Average temperature in degrees Celsius. 1950 –⁠ 2000 average.",
	"useHighResMaps": false,
	"maps": [
		{
			"name": "tmean_1c",
			"displayName": "Jan."
		},
		{
			"name": "tmean_2c",
			"displayName": "Feb."
		},
		{
			"name": "tmean_3c",
			"displayName": "Mar."
		},
		{
			"name": "tmean_4c",
			"displayName": "Apr."
		},
		{
			"name": "tmean_5c",
			"displayName": "May"
		},
		{
			"name": "tmean_6c",
			"displayName": "Jun."
		},
		{
			"name": "tmean_7c",
			"displayName": "Jul."
		},
		{
			"name": "tmean_8c",
			"displayName": "Aug."
		},
		{
			"name": "tmean_9c",
			"displayName": "Sep."
		},
		{
			"name": "tmean_10c",
			"displayName": "Oct."
		},
		{
			"name": "tmean_11c",
			"displayName": "Nov."
		},
		{
			"name": "tmean_12c",
			"displayName": "Dec."
		}
	],
	"gradientMin": "−22",
	"gradientMax": "38",
	"gradientStyle": "temperature"
};


//////////////////
// WEBPACK FOOTER
// ./src/resources/data/temperature-info.json
// module id = 1153
// module chunks = 0